var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "MaterialInput",
          {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:250",
                expression: "'required|max:250'",
              },
            ],
            staticClass: "city-form-group city-bg",
            attrs: {
              id: "input-name",
              readonly: _vm.readonlyFormItem,
              type: "text",
              name: "name",
              inputClasses: [{ "is-invalid": _vm.fnHasError(`name`) }],
              error: _vm.fnFirstError(`name`),
            },
            model: {
              value: _vm.value.name,
              callback: function ($$v) {
                _vm.$set(
                  _vm.value,
                  "name",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "value.name",
            },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t(`${_vm.pageID}.model.name`)) + "\n    "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-6" },
      [
        _c(
          "MaterialInput",
          {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "emails",
                expression: "'emails'",
              },
            ],
            staticClass: "city-form-group city-bg",
            attrs: {
              id: "input-email",
              readonly: _vm.readonlyFormItem,
              type: "text",
              name: "email",
              inputClasses: [{ "is-invalid": _vm.fnHasError(`email`) }],
              error: _vm.fnFirstError(`email`),
            },
            model: {
              value: _vm.value.email,
              callback: function ($$v) {
                _vm.$set(
                  _vm.value,
                  "email",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "value.email",
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t(`${_vm.pageID}.model.email`)) +
                "\n    "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-6" },
      [
        _c(
          "MaterialInput",
          {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "numeric|min_value:1|min:9|max:14",
                expression: "'numeric|min_value:1|min:9|max:14'",
              },
            ],
            staticClass: "city-form-group city-bg",
            attrs: {
              id: "input-phone",
              readonly: _vm.readonlyFormItem,
              type: "text",
              name: "phone",
              inputClasses: [{ "is-invalid": _vm.fnHasError(`phone`) }],
              error: _vm.fnFirstError(`phone`),
            },
            model: {
              value: _vm.value.phone,
              callback: function ($$v) {
                _vm.$set(
                  _vm.value,
                  "phone",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "value.phone",
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t(`${_vm.pageID}.model.phone`)) +
                "\n    "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c(
          "MaterialSelect",
          {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            staticClass: "city-form-group city-bg",
            attrs: {
              id: "input-status",
              disabled: _vm.readonlyFormItem,
              name: "status",
              label: "name",
              filterable: true,
              options: _vm.lists.onoff,
              reduce: (option) => option.code,
              inputClasses: [{ "is-invalid": _vm.fnHasError("status") }],
              error: _vm.fnFirstError("status"),
            },
            model: {
              value: _vm.value.status,
              callback: function ($$v) {
                _vm.$set(
                  _vm.value,
                  "status",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "value.status",
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t(`${_vm.pageID}.model.status`)) +
                "\n    "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }